import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, normalizeStyle as _normalizeStyle, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "form" }
const _hoisted_2 = {
  key: 0,
  class: "center title"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "thanksMessage center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "thanksMessage center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 0,
  class: "center claim"
}
const _hoisted_10 = {
  key: 1,
  class: "center claim"
}
const _hoisted_11 = { class: "form-row" }
const _hoisted_12 = {
  key: 0,
  class: "form-field"
}
const _hoisted_13 = { class: "pageLabel" }
const _hoisted_14 = {
  key: 1,
  class: "form-field"
}
const _hoisted_15 = { class: "floating-label-wrap" }
const _hoisted_16 = {
  for: "firstName",
  class: "floating-label"
}
const _hoisted_17 = {
  key: 0,
  id: "firstName-error",
  class: "has-error",
  for: "firstName"
}
const _hoisted_18 = {
  key: 2,
  class: "form-field"
}
const _hoisted_19 = { class: "floating-label-wrap" }
const _hoisted_20 = {
  for: "lastName",
  class: "floating-label"
}
const _hoisted_21 = {
  key: 0,
  id: "lastName-error",
  class: "has-error",
  for: "lastName"
}
const _hoisted_22 = {
  key: 3,
  class: "form-field"
}
const _hoisted_23 = { class: "floating-label-wrap" }
const _hoisted_24 = {
  for: "email",
  class: "floating-label"
}
const _hoisted_25 = {
  key: 0,
  id: "email-error",
  class: "has-error",
  for: "email"
}
const _hoisted_26 = {
  key: 4,
  class: "form-field"
}
const _hoisted_27 = { class: "floating-label-wrap" }
const _hoisted_28 = {
  for: "phone",
  class: "floating-label"
}
const _hoisted_29 = {
  key: 0,
  id: "phone-error",
  class: "has-error",
  for: "phone"
}
const _hoisted_30 = {
  key: 5,
  class: "form-field"
}
const _hoisted_31 = { class: "floating-label-wrap" }
const _hoisted_32 = {
  for: "company",
  class: "floating-label"
}
const _hoisted_33 = {
  key: 0,
  id: "company-error",
  class: "has-error",
  for: "company"
}
const _hoisted_34 = {
  key: 6,
  class: "form-field"
}
const _hoisted_35 = { class: "floating-label-wrap" }
const _hoisted_36 = {
  for: "role",
  class: "floating-label"
}
const _hoisted_37 = {
  key: 0,
  id: "role-error",
  class: "has-error",
  for: "role"
}
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { style: {"clear":"both","width":"100%","padding-top":"10px"} }
const _hoisted_40 = {
  key: 0,
  class: "form-field",
  style: {"margin-top":"0px"}
}
const _hoisted_41 = ["value"]
const _hoisted_42 = {
  key: 1,
  class: "form-field",
  style: {"margin-top":"0px"}
}
const _hoisted_43 = ["value"]
const _hoisted_44 = { style: {"float":"left","width":"50%"} }
const _hoisted_45 = { class: "form-field" }
const _hoisted_46 = { class: "privacyregistration" }
const _hoisted_47 = { style: {"float":"right","width":"46%"} }
const _hoisted_48 = { class: "form-field" }
const _hoisted_49 = { class: "privacyregistration" }
const _hoisted_50 = { class: "form-field" }
const _hoisted_51 = ["min", "disabled"]
const _hoisted_52 = { class: "form-field" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = ["value"]
const _hoisted_55 = { style: {"clear":"both","width":"100%","padding-top":"10px"} }
const _hoisted_56 = {
  key: 0,
  class: "no-bold",
  style: {"margin-top":"0"}
}
const _hoisted_57 = { key: 8 }
const _hoisted_58 = { class: "form-field" }
const _hoisted_59 = {
  key: 0,
  id: "notes-error",
  class: "has-error",
  for: "notes"
}
const _hoisted_60 = {
  key: 9,
  class: "form-field"
}
const _hoisted_61 = {
  class: "privacyregistration",
  style: {"margin-top":"25px"}
}
const _hoisted_62 = ["href"]
const _hoisted_63 = {
  key: 0,
  id: "privacy-error",
  class: "has-error",
  for: "role"
}
const _hoisted_64 = {
  key: 10,
  class: "form-field"
}
const _hoisted_65 = {
  class: "privacyregistration",
  style: {"margin-top":"25px"}
}
const _hoisted_66 = {
  key: 0,
  id: "data-error",
  class: "has-error",
  for: "role"
}
const _hoisted_67 = {
  key: 11,
  class: "form-field"
}
const _hoisted_68 = {
  class: "privacyregistration",
  style: {"margin-top":"25px"}
}
const _hoisted_69 = ["href"]
const _hoisted_70 = {
  class: "center",
  style: {"margin-top":"15px"}
}
const _hoisted_71 = { style: {"float":"left","width":"50%","text-align":"left"} }
const _hoisted_72 = ["disabled"]
const _hoisted_73 = { style: {"float":"right","width":"50%","text-align":"right"} }
const _hoisted_74 = ["disabled"]
const _hoisted_75 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.titleExists)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_ctx.t("common.title")), 1))
        : _createCommentVNode("", true),
      (_ctx.showThanksMsg)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t("common.msgThanksFirstRow")), 1),
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.t("common.msgThanksSecondRow")), 1),
            _hoisted_7
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_ctx.claimExists)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_9, _toDisplayString(_ctx.t("common.claim")), 1))
              : _createCommentVNode("", true),
            (_ctx.twoStepsVersion && _ctx.pageTitleExists)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_10, _toDisplayString(_ctx.pageTitle), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              (_ctx.personalDataLabelExists && _ctx.twoStepsVersion && _ctx.stepVisible == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.t("common.personalDataLabel")), 1)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.twoStepsVersion || _ctx.stepVisible == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.custFirstName) = $event)),
                        class: _normalizeClass(["form-input form-input-text floating-label-field floating-label-field--s3", !_ctx.validationFirstName? 'has-error' : '']),
                        id: "firstName",
                        placeholder: "firstName"
                      }, null, 2), [
                        [_vModelText, _ctx.custFirstName]
                      ]),
                      _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("common.firstName")) + " *", 1)
                    ]),
                    (!_ctx.validationFirstName)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_17, _toDisplayString(_ctx.t("common.firstNameRequired")), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.twoStepsVersion || _ctx.stepVisible == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.custLastName) = $event)),
                        class: _normalizeClass(["form-input form-input-text floating-label-field floating-label-field--s3", !_ctx.validationLastName? 'has-error' : '']),
                        id: "lastName",
                        placeholder: "lastName"
                      }, null, 2), [
                        [_vModelText, _ctx.custLastName]
                      ]),
                      _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.t("common.lastName")) + " *", 1)
                    ]),
                    (!_ctx.validationLastName)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_21, _toDisplayString(_ctx.t("common.lastNameRequired")), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.twoStepsVersion || _ctx.stepVisible == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.custEmail) = $event)),
                        class: _normalizeClass(["form-input form-input-text floating-label-field floating-label-field--s3", !_ctx.validationEmail? 'has-error' : '']),
                        id: "email",
                        placeholder: "email"
                      }, null, 2), [
                        [_vModelText, _ctx.custEmail]
                      ]),
                      _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.t("common.emailAddress")) + " *", 1)
                    ]),
                    (!_ctx.validationEmail)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_25, _toDisplayString(_ctx.t("common.emailAddressRequired")), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.twoStepsVersion || _ctx.stepVisible == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.custPhone) = $event)),
                        class: _normalizeClass(["form-input form-input-text floating-label-field floating-label-field--s3", !_ctx.validationPhone? 'has-error' : '']),
                        id: "phone",
                        placeholder: "phone"
                      }, null, 2), [
                        [_vModelText, _ctx.custPhone]
                      ]),
                      _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.t("common.phoneNumber")) + " *", 1)
                    ]),
                    (!_ctx.validationPhone)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_29, _toDisplayString(_ctx.t("common.phoneNumberRequired")), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.companyAndRoleVisible && (!_ctx.twoStepsVersion || _ctx.stepVisible == 2))
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.custCompany) = $event)),
                        class: _normalizeClass(["form-input form-input-text floating-label-field floating-label-field--s3", !_ctx.validationCompany? 'has-error' : '']),
                        id: "company",
                        placeholder: "company"
                      }, null, 2), [
                        [_vModelText, _ctx.custCompany]
                      ]),
                      _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.t("common.company")) + " *", 1)
                    ]),
                    (!_ctx.validationCompany)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_33, _toDisplayString(_ctx.t("common.companyRequired")), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.companyAndRoleVisible && (!_ctx.twoStepsVersion || _ctx.stepVisible == 2))
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.custRole) = $event)),
                        class: _normalizeClass(["form-input form-input-text floating-label-field floating-label-field--s3", !_ctx.validationRole? 'has-error' : '']),
                        id: "role",
                        placeholder: "role"
                      }, null, 2), [
                        [_vModelText, _ctx.custRole]
                      ]),
                      _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.t("common.role")) + " *", 1)
                    ]),
                    (!_ctx.validationRole)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_37, _toDisplayString(_ctx.t("common.roleRequired")), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.twoStepsVersion || _ctx.stepVisible == 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                    (_ctx.labelTypeExists)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_38, _toDisplayString(_ctx.t("common.labelType")), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_39, [
                      (_ctx.custType === 'field')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            _withDirectives(_createElementVNode("select", {
                              class: "form-input form-input-data",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.custFieldId) = $event)),
                              style: {"width":"100%"}
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (f) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: f.id,
                                  value: f.id
                                }, _toDisplayString(f.name), 9, _hoisted_41))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, _ctx.custFieldId]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.custType === 'expert')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            _withDirectives(_createElementVNode("select", {
                              class: "form-input form-input-data",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.custExpertId) = $event)),
                              style: {"width":"100%"}
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.experts, (e) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: e.id,
                                  value: e.id
                                }, _toDisplayString(e.cognome + ' ' + e.nome), 9, _hoisted_43))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, _ctx.custExpertId]
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("label", null, _toDisplayString(_ctx.t("common.labelWhen")), 1),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("label", _hoisted_46, [
                          _withDirectives(_createElementVNode("input", {
                            class: "we-radio form-input",
                            type: "radio",
                            id: "optAsSoon",
                            name: "optAsSoon",
                            value: "true",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.custAsSoon) = $event))
                          }, null, 512), [
                            [_vModelRadio, _ctx.custAsSoon]
                          ]),
                          _createElementVNode("span", {
                            class: _normalizeClass(_ctx.dateDisabled === true ? 'bold' : 'no-bold')
                          }, _toDisplayString(_ctx.t("common.labelWhenAsSoon")), 3)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("label", _hoisted_49, [
                          _withDirectives(_createElementVNode("input", {
                            class: "we-radio form-input",
                            type: "radio",
                            id: "optAsSoon",
                            name: "optAsSoon",
                            value: "false",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.custAsSoon) = $event))
                          }, null, 512), [
                            [_vModelRadio, _ctx.custAsSoon]
                          ]),
                          _createElementVNode("span", {
                            class: _normalizeClass(_ctx.dateDisabled === false ? 'bold' : 'no-bold')
                          }, _toDisplayString(_ctx.t("common.labelWhenDate")), 3)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", {
                      style: _normalizeStyle([{"float":"left","width":"50%","text-align":"left"}, _ctx.dateDisabled === true ? 'visibility:hidden' : 'visibility:visible'])
                    }, [
                      _createElementVNode("div", _hoisted_50, [
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          min: _ctx.today,
                          class: "form-input form-input-data",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.custRequiredDateModel) = $event)),
                          disabled: _ctx.dateDisabled,
                          style: {"width":"90%"}
                        }, null, 8, _hoisted_51), [
                          [_vModelText, _ctx.custRequiredDateModel]
                        ])
                      ])
                    ], 4),
                    _createElementVNode("div", {
                      style: _normalizeStyle([{"float":"right","width":"50%","text-align":"right"}, _ctx.dateDisabled === true ? 'visibility:hidden' : 'visibility:visible'])
                    }, [
                      _createElementVNode("div", _hoisted_52, [
                        _withDirectives(_createElementVNode("select", {
                          class: "form-input form-input-data",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.custRequiredHour) = $event)),
                          disabled: _ctx.dateDisabled,
                          style: {"width":"90%"}
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hours, (hour) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: hour.hourValue,
                              value: hour.hourValue
                            }, _toDisplayString(hour.displayValue), 9, _hoisted_54))
                          }), 128))
                        ], 8, _hoisted_53), [
                          [_vModelSelect, _ctx.custRequiredHour]
                        ])
                      ])
                    ], 4),
                    _createElementVNode("div", _hoisted_55, [
                      (_ctx.labelWeWillContactYouExists)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_56, _toDisplayString(_ctx.t("common.labelWeWillContactYou")), 1))
                        : _createCommentVNode("", true)
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.notesVisible && _ctx.stepVisible == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("label", null, _toDisplayString(_ctx.t("common.notes")), 1),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.custNotes) = $event)),
                        rows: "4",
                        class: _normalizeClass(["form-input form-input-textarea", !_ctx.validationNotes? 'has-error' : '']),
                        id: "notes"
                      }, null, 2), [
                        [_vModelText, _ctx.custNotes]
                      ])
                    ]),
                    (!_ctx.validationNotes)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_59, _toDisplayString(_ctx.t("common.notesRequired")), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.chkPrivacyVisible && (!_ctx.twoStepsVersion || _ctx.stepVisible == 2))
                ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                    _createElementVNode("label", _hoisted_61, [
                      (_ctx.chkPrivacyCallback)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _withDirectives(_createElementVNode("input", {
                              class: "we-checkbox form-input form-input-chk",
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.custPrivacyChecked) = $event)),
                              id: "Privacy1",
                              name: "Privacy1",
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.privacyCheck($event, false)))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.custPrivacyChecked]
                            ]),
                            _createTextVNode(" " + _toDisplayString(_ctx.t("common.privacyText")) + " ", 1),
                            _createElementVNode("a", {
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.privacyCheck($event, true)))
                            }, _toDisplayString(_ctx.t("common.privacyLink")), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _withDirectives(_createElementVNode("input", {
                              class: "we-checkbox form-input form-input-chk",
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.custPrivacyChecked) = $event)),
                              id: "Privacy1",
                              name: "Privacy1"
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.custPrivacyChecked]
                            ]),
                            _createTextVNode(" " + _toDisplayString(_ctx.t("common.privacyText")) + " ", 1),
                            _createElementVNode("a", {
                              href: _ctx.privacyPolicyLink,
                              target: "_blank"
                            }, _toDisplayString(_ctx.t("common.privacyLink")), 9, _hoisted_62)
                          ], 64))
                    ]),
                    (!_ctx.validationPrivacyChk)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_63, _toDisplayString(_ctx.t("common.privacyRequired")), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.chkDataConsentVisible && (!_ctx.twoStepsVersion || _ctx.stepVisible == 2))
                ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                    _createElementVNode("label", _hoisted_65, [
                      _withDirectives(_createElementVNode("input", {
                        class: "we-checkbox form-input form-input-chk",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.custDataConsentChecked) = $event)),
                        id: "Privacy3",
                        name: "Privacy3"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.custDataConsentChecked]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.dataConsentText")), 1)
                    ]),
                    (!_ctx.validationDataChk)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_66, _toDisplayString(_ctx.t("common.dataConsentRequired")), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.chkMarketingVisible && (!_ctx.twoStepsVersion || _ctx.stepVisible == 2))
                ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                    _createElementVNode("label", _hoisted_68, [
                      _withDirectives(_createElementVNode("input", {
                        class: "we-checkbox form-input form-input-chk",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.custMarketingChecked) = $event)),
                        id: "Privacy2",
                        name: "Privacy2"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.custMarketingChecked]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.marketingText")) + " (", 1),
                      _createElementVNode("a", {
                        href: _ctx.marketingPolicyLink,
                        target: "_blank"
                      }, _toDisplayString(_ctx.t("common.marketingLink")), 9, _hoisted_69),
                      _createTextVNode(") ")
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_70, [
                (_ctx.twoStepsVersion)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("button", {
                          disabled: _ctx.stepVisible == 1,
                          class: "btn white bggray bold",
                          onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
                          style: {"width":"90%"}
                        }, "Indietro", 8, _hoisted_72)
                      ]),
                      _createElementVNode("div", _hoisted_73, [
                        (_ctx.stepVisible == 1)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn white bgmain bold",
                              onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.goOn && _ctx.goOn(...args))),
                              style: {"width":"90%"}
                            }, "Avanti"))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "btn white bgmain bold",
                              onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.create && _ctx.create(...args))),
                              style: {"width":"90%"},
                              disabled: _ctx.isCreating
                            }, _toDisplayString(_ctx.t("common.btnCreate")), 9, _hoisted_74))
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn white bgmain bold",
                      onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.create && _ctx.create(...args))),
                      disabled: _ctx.createDisabled
                    }, _toDisplayString(_ctx.t("common.btnCreate")), 9, _hoisted_75))
              ])
            ])
          ]))
    ]),
    _createVNode(_component_Popup, { ref: "popupResult" }, {
      default: _withCtx(() => [
        _createTextVNode(" PROVA POPUP ")
      ]),
      _: 1
    }, 512)
  ], 64))
}